import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import {FormFieldComponent} from '../../shared/components/form-field/form-field.component';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {SlideTogglePadraoComponent} from '../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import {ValidacaoAlteracaoCampoService} from '../../shared/service/utilitarios/validacao-alteracao-campo.service';
import {FluxoSalvarModel} from '../../shared/model/fluxo/fluxo-salvar-model';
import {TipoFluxoEnum} from '../../shared/enum/tipo-fluxo.enum';

@Component({
  selector: 'app-modal-cadastro-visualizacao-pesquisa',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    FormFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    SlideTogglePadraoComponent
  ],
  templateUrl: './modal-cadastro-visualizacao-pesquisa.component.html',
  styleUrl: './modal-cadastro-visualizacao-pesquisa.component.css'
})
export class ModalCadastroVisualizacaoPesquisaComponent implements OnInit {
  formGroupPesquisa!: FormGroup;
  visualizar = false;
  pesquisa: FluxoSalvarModel = new FluxoSalvarModel();

  private readonly dialog = inject(MatDialogRef<ModalCadastroVisualizacaoPesquisaComponent>);
  public data: any = inject(MAT_DIALOG_DATA);
  public readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);
  private readonly fb = inject(FormBuilder);

  ngOnInit() {
    this.formGroupPesquisa = this.fb.group({
      titulo: ['', [Validators.required, Validators.maxLength(25)]],
      descricao: ['', []],
    });

    this.visualizar = this.data['visualizar'];
    this.pesquisa = this.data['pesquisa'];

    this.formGroupPesquisa.get('titulo')?.patchValue(this.pesquisa.titulo);
    this.formGroupPesquisa.get('descricao')?.patchValue(this.pesquisa.descricao);
  }

  salvar() {
    this.pesquisa.titulo = this.formGroupPesquisa.value.titulo;
    this.pesquisa.descricao = this.formGroupPesquisa.value.descricao;
    this.pesquisa.tipo = TipoFluxoEnum.PESQUISA;
    this.dialog.close(this.pesquisa);
  }
  cancelar() { this.dialog.close(); }
}
